$(function(){
  $('.textillate').textillate({
    in: {
      effect: "bounceInDown"
    },
    out: {
      effect: "bounceOutUp"
    }
  });
});
